import React, { Component } from "react";
import ReactDOM from "react-dom";
import noUiSlider from "nouislider";

class FilterRange extends Component {
  constructor(props) {
    super(props);
    const { filter } = props;

    const bins = filter.Bins ?? [];
    const minAll = Number(filter.Min ?? 0);
    const maxAll = Number(filter.Max ?? 0);

    const rangeMap = { min: minAll };
    const n = Math.max(1, bins.length);
    bins.forEach((b, i) => {
      const from = Number(b.From);
      const pct = (i * 100) / n;       
      rangeMap[`${pct.toFixed(3)}%`] = from; 
    });
    rangeMap.max = maxAll;

    const edges = [
      minAll,
      ...bins.map(b => Number(b.From)),
      maxAll,
    ];

    const snapToEdge = (val) => {
      let best = edges[0];
      let bestDist = Math.abs(val - best);
      for (let i = 1; i < edges.length; i++) {
        const d = Math.abs(val - edges[i]);
        if (d < bestDist) {
          bestDist = d;
          best = edges[i];
        }
      }
      return best;
    };

    const curMin = Number(filter.CurrentMin ?? minAll);
    const curMax = Number(filter.CurrentMax ?? maxAll);

    const startLoRaw = Math.min(Math.max(curMin, minAll), maxAll);
    const startHiRaw = Math.min(Math.max(curMax, minAll), maxAll);
    const startRaw = startLoRaw <= startHiRaw ? [startLoRaw, startHiRaw] : [minAll, maxAll];

    const start = [snapToEdge(startRaw[0]), snapToEdge(startRaw[1])].sort((a, b) => a - b);

    this.min = minAll;
    this.max = maxAll;

    this.name = filter.Name;
    this.paramFrom = `${filter.Name}From`;
    this.paramTo = `${filter.Name}To`;

    this._rangeMap = rangeMap;

    this.state = { range: start, rangeRaw: startRaw };
    this.sliderRef = React.createRef();
  }

  componentDidMount() {
    const min = this.min;
    const max = this.max;
    if (min === max) 
    {
      return;
    }

    noUiSlider.create(this.sliderRef.current, {
      start: this.state.range,
      connect: true,
      range: this._rangeMap, 
      snap: true, 
      behaviour: "tap-drag",
    });

    this.sliderRef.current.noUiSlider.on("update", (values) => {
      this.setState({ range: values.map(parseFloat) });
    });

    this.sliderRef.current.noUiSlider.on("change", (values) => {
      const [a, b] = values.map(parseFloat);
      const lo = Math.floor(Math.min(Math.max(a, min), max));
      const hi = Math.ceil(Math.min(Math.max(b, min), max));

      const url = new URL(window.location.href);
      url.searchParams.set(this.paramFrom, String(lo));
      url.searchParams.set(this.paramTo, String(hi));
      window.location.href = url.toString();
    });
  }

  componentWillUnmount() {
    if (this.sliderRef.current?.noUiSlider) {
      this.sliderRef.current.noUiSlider.destroy();
    }
  }

  render() {
    const { filter, labelFrom, labelTo } = this.props;
    const bins = filter.Bins ?? [];
    const counts = bins.map(b => b.Count ?? 0);
    const maxCount = Math.max(1, ...counts);
    const { range, rangeRaw } = this.state;

    return (
      <div className="filter-range-card">
        <div className="range-summary" style={{marginBottom: 6}}>
          {labelFrom} {rangeRaw[0]}{filter.Unit} – {labelTo} {rangeRaw[1]}{filter.Unit}
        </div>
        <div className="histogram" aria-hidden="true">
          {bins.map((b, i) => {
            const from = Number(b.From);
            const to = Number(b.To);
            const hgt = Math.round((counts[i] / maxCount) * 100);
            const inside = to > range[0] && from < range[1];
            return (
              <div
                key={i}
                className={"bar" + (inside ? "" : " dim")}
                title={`${from.toFixed(2)}–${to.toFixed(2)}: ${counts[i]}`}
                style={{ height: `${8 + hgt}px`, flex: "0 0 " + (100 / Math.max(1, bins.length)) + "%" }}
              />
            );
          })}
        </div>

        <div ref={this.sliderRef} className="filter-range-slider" style={{ margin: "6px 6px 0" }} />

        <div className="labels">
          <span>{range[0].toFixed(0)} {filter.Unit}</span>
          <span>{range[1].toFixed(0)} {filter.Unit}</span>
        </div>
      </div>
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const nodes = document.querySelectorAll(".app-filter-range");
  if (!nodes.length) return;

  nodes.forEach(host => {
    const filter = JSON.parse(host.dataset.values);
    const labelFrom = host.dataset.labelfrom || "from";
    const labelTo = host.dataset.labelto || "to";
    ReactDOM.render(<FilterRange filter={filter} labelFrom={labelFrom} labelTo={labelTo} />, host.querySelector(".body") || host);
  });
});